/* eslint-disable react/jsx-no-useless-fragment */
import { Children, useMemo } from 'react'

interface Props {
  text: string
}

export function SimpleMarkdown({ text }: Props) {
  const parsed = useMemo(() => parseMarkdown(text), [text])

  return <>{Children.toArray(parsed)}</>
}

function parseMarkdown(text: string): JSX.Element[] {
  const elements = new Array<JSX.Element>()

  type Entry = { type: 'strong' | 'em' | 'span', text: string }
  const stack = Array.from([{ type: 'span', text: '' }] as Entry[])
  let asterisksQueue = new Array<number>()

  const elementTypes = {
    0: 'span',
    1: 'em',
    2: 'strong',
  } as const

  const addElement = (entry: Entry) => {
    elements.push(<entry.type>{entry.text}</entry.type>)
    entry.text = ''
  }

  for (let i = 0; i < text.length; i++) {
    const char = text[i]
    const prev = text[i - 1]
    const next = text[i + 1]

    if (char === '\\' && next === '*') continue

    if (char === '*' && prev !== '\\') {
      asterisksQueue.push(i)
      if (asterisksQueue.length in elementTypes === false) throw new Error('Invalid asterisk sequence')
      if (next === '*') continue
      const entry = {
        type: elementTypes[asterisksQueue.length as keyof typeof elementTypes],
        text: '',
      }

      const prevEntry = stack[stack.length - 1]

      if (prevEntry.type !== entry.type) {
        addElement(prevEntry)
        stack.push(entry)
      } else {
        const entry = stack.pop()!
        addElement(entry)
      }
    } else {
      asterisksQueue = []
      stack[stack.length - 1].text += char
    }
  }

  const lastEntry = stack.pop()
  if (lastEntry?.type === 'span')
    addElement(lastEntry)

  return elements
}
